import React from "react";

import { Avatar, colors, makeStyles } from "@material-ui/core";
import { Check as CheckIcon, Lock as LockIcon } from "react-feather";
import clsx from "clsx";

import { CapacityAvatarProps } from "./types";

import FullCapIcon from "./images/FullCapIcon";

const useStyles = makeStyles({
  avatar: {
    height: 48,
    width: 48,
  },
  successAvatar: {
    backgroundColor: colors.green[500],
  },
  errorAvatar: {
    backgroundColor: colors.red[600],
  },
});

const CapacityAvatar: React.FC<CapacityAvatarProps> = ({
  hasCapacity,
  isLocked,
}: CapacityAvatarProps) => {
  const classes = useStyles();

  if (isLocked) {
    return (
      <Avatar
        data-test="learner-capacity-lock-icon"
        className={clsx(classes.avatar, classes.errorAvatar)}
      >
        <LockIcon />
      </Avatar>
    );
  }

  return hasCapacity ? (
    <Avatar
      data-test="learner-capacity-check-icon"
      className={clsx(classes.avatar, classes.successAvatar)}
    >
      <CheckIcon />
    </Avatar>
  ) : (
    <Avatar
      data-test="learner-capacity-lock-icon"
      className={clsx(classes.avatar, classes.errorAvatar)}
    >
      <FullCapIcon />
    </Avatar>
  );
};

export default CapacityAvatar;
